import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Button from '../UniformComponents/Button'
import Modal from '../UniformComponents/Modal'
import ProductEditStore from './ProductEditStore'
import FormController from '../components/form/FormController'
import InfoAccordion from '../components/InfoAccordion'
import RecordTag from '../components/RecordTags'

@observer
class ProductEdit extends Component {
    stages = [
        i18n.t('product'),
    ]

    constructor(props) {
        super(props)
        this.fields = {}
        this.productEditStore = new ProductEditStore(props.store)
        this.state = {
            openAccordion: false,
            curKey: '0',
            isNewEvent: false,
        }
    }

    async componentDidUpdate(prevProps) {
        const { showModal } = this.props

        if (showModal && !prevProps.showModal) {
            await this.init()
            this.setState({ curKey: '0' })
        }
    }

    init = async () => {
        const {
            store, productId, industryCode, handleCloseModal,
        } = this.props

        this.setState({ isNewEvent: productId === 0 })
        this.productEditStore.resetFormState()

        await this.productEditStore.initProduct(productId, industryCode, '', handleCloseModal)

        if (this.productEditStore.invalidProduct) {
            handleCloseModal()
        } else store.loading = false
    }

    toggleAccordion = () => {
        this.setState((prevState) => ({
            openAccordion: !prevState.openAccordion,
        }))
    }

    register = (name, validate, path) => {
        this.fields[name] = {
            validate,
            path,
        }
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    areProductFieldsValid = (product) => Object.keys(this.fields).map((key) => {
        const validate = R.pathOr(this.fields[key], ['validate'], this.fields[key])
        const path = R.pathOr(null, ['path'], this.fields[key])
        const value = !R.isNil(path)
            ? R.pathOr(undefined, path)(product)
            : product[key]

        const a = validate({
            value,
            name: key,
        }, true)

        return a
    }).every((valid) => valid)

    areRecordTagsValid = () => this.productEditStore.availableTags.map((availTag) => {
        if (!availTag.isMandatory) return true
        const foundTag = this.productEditStore.recordTags[availTag.tagId]
        if (!foundTag) return false
        if (typeof foundTag === 'string' && !foundTag.length) return false
        return true
    }).every((valid) => valid)

    save = async () => {
        const { store, productId, handleCloseModal } = this.props
        const { product } = this.productEditStore

        const fieldsValid = this.areProductFieldsValid(product)
        const recordTagsValid = this.areRecordTagsValid()
        if (!fieldsValid || !recordTagsValid) return
        // remove privilege fields if not an admin
        if (!(store.isExploriAdmin() || store.isSuperUser())) {
            delete product.privilegedFields
        }

        const isEditing = parseInt(productId, 10) !== 0
        try {
            const method = isEditing
                ? 'put'
                : 'post'

            const url = isEditing
                ? `/product/${productId}`
                : '/product'

            const response = await store.http[method](url, JSON.stringify(product))
            await this.productEditStore.saveTags(R.path([0, 'productId'], response))
            handleCloseModal()
            store.addNotification(null, `${isEditing ? i18n.t('update_event') : i18n.t('create_event')}`, 'success')
        } catch (e) {
            const msg = R.pathOr('Error creating or updating product', ['message'])(e)
            if (msg.match(/licence/gi)) {
                store.addNotification(
                    null, i18n.t('not_enough_licences_to_add_new_product'), 'error',
                )
            } else {
                store.addNotification(null, msg, 'error')
            }
        }
    }

    setField = (data) => {
        const { productId } = this.props
        this.productEditStore.setField(data, productId)
    }

    renderEventForm = () => {
        const { handleCloseModal } = this.props
        const { openAccordion, isNewEvent } = this.state
        return (
            <Fragment>
                <div className="accordion-wrapper">
                    { isNewEvent && (
                        <InfoAccordion
                            title={i18n.t('product.form.accordion.title')}
                            show={openAccordion}
                            toggle={this.toggleAccordion}
                        >
                            <p>{i18n.t('product.form.event.accordion.desc')}</p>
                        </InfoAccordion>
                    )}
                </div>
                <FormController
                    fields={this.fields}
                    formFields={this.productEditStore.formFields}
                    setField={this.setField}
                />
                <br />
                <br />
                <RecordTag
                    values={this.productEditStore.recordTags}
                    availableTags={this.productEditStore.availableTags}
                    onBlur={this.productEditStore.setTag}
                    register={this.register}
                    unregister={this.unregister}
                />
                <div className="form-button-wrapper">
                    <Button
                        label={i18n.t('close')}
                        cssClass="regular tertiary"
                        onClick={handleCloseModal}
                    />
                    <Button
                        label={i18n.t('save')}
                        icon="fa-light fa-floppy-disk"
                        cssClass="regular primary"
                        onClick={this.save}
                    />
                </div>
            </Fragment>
        )
    }

    render() {
        const {
            showModal, productId, handleCloseModal,
        } = this.props
        const { curKey } = this.state
        const { formLoading } = this.productEditStore
        const tabs = {
            0: {
                title: productId !== 0 ? i18n.t('product.editEvent') : i18n.t('product.createNewEvent'),
                label: productId !== 0 ? i18n.t('product.editEvent') : i18n.t('product.newEvent'),
                render: this.renderEventForm,
            },
        }

        return (
            <Modal
                show={showModal}
                onClose={handleCloseModal}
                loading={formLoading}
                cssClass="large"
            >
                <div className="form-tabs-header">
                    <h2 className="title">{tabs[curKey].title}</h2>
                    {/* <div className="tab-btns">
                        {Object.keys(tabs).map((key) => (
                            <Button
                                cssClass={`tab ${curKey === key ? 'selected' : ''}`}
                                label={tabs[key].label}
                                onClick={() => { this.setState({ curKey: key }) }}
                            />
                        ))}
                    </div> */}
                </div>
                {tabs[curKey].render()}
            </Modal>
        )
    }
}

export default ProductEdit
